import { render, staticRenderFns } from "./OperaNoticeWindow.vue?vue&type=template&id=54f91ad8&scoped=true&"
import script from "./OperaNoticeWindow.vue?vue&type=script&lang=js&"
export * from "./OperaNoticeWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaNoticeWindow.vue?vue&type=style&index=0&id=54f91ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f91ad8",
  null
  
)

export default component.exports